import React from 'react';
import { useSelector } from 'react-redux';
import DefaultLayout from '../../../layouts/default';
import { selectCanManageUsers } from '../../../features/users/usersSlice';
import { DepartmentProvider, useDepartments } from './context/DepartmentContext';
import DepartmentHeader from './components/DepartmentHeader';
import DepartmentTable from './components/DepartmentTable';
import DepartmentFormDialog from './components/DepartmentFormDialog';
function Content() { const { form } = useDepartments(); return <><DepartmentHeader /><DepartmentTable />{form && <DepartmentFormDialog />}</>; }
export default function DepartmentsPage() {
  const allowed = useSelector(selectCanManageUsers);
  return <DefaultLayout>{allowed ? <DepartmentProvider><Content /></DepartmentProvider> : <p role="alert" className="rounded-xl bg-white p-6 text-sm text-slate-600">Only administrators can manage departments.</p>}</DefaultLayout>;
}
